var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"financial-reports-2018"},_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,attrs:{"src":item,"alt":"","srcset":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }